import { render } from "./leaves-admin-header.vue?vue&type=template&id=3bd08f58"
import script from "./leaves-admin-header.vue?vue&type=script&lang=js"
export * from "./leaves-admin-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__